export default "__VITE_ASSET__l4Hh$HsV__"